import { connect } from 'react-redux';

import {
  getIsHotelOnly,
  getIsMobile,
  searchTypeSelector,
} from 'src/store/view/selectors';
import { getIsAdmin } from 'src/store/client/selectors';
import {
  getSimilarPackagesOffers,
  getSimilarPackagesHotelOffersCount,
  getSimilarPackageIsPopupOpened,
  getSimilarPackagesHasAdjustParams,
  getSimilarPackagesState,
} from '../../../store/selectors/similar-packages';
import {
  similarPackagesPopupClosedAction,
  createPackageAction,
} from '../../../store/actions/similar-packages';
import { SimilarPackagesContainer } from './SimilarPackagesContainer';

const mapStateToProps = (state) => ({
  similarOffers: getSimilarPackagesOffers(state),
  hotelOffersCount: getSimilarPackagesHotelOffersCount(state),
  isPopupOpened: getSimilarPackageIsPopupOpened(state),
  isAdmin: getIsAdmin(state),
  hasAdjustParams: getSimilarPackagesHasAdjustParams(state),
  status: getSimilarPackagesState(state),
  isHotelOnly: getIsHotelOnly(state),
  searchType: searchTypeSelector(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = {
  onClose: similarPackagesPopupClosedAction,
  onClick: createPackageAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SimilarPackagesContainer);
